import { render, staticRenderFns } from "./OrderChooseDiagnosticTimeTable.vue?vue&type=template&id=58df30c0&scoped=true&"
import script from "./OrderChooseDiagnosticTimeTable.vue?vue&type=script&lang=js&"
export * from "./OrderChooseDiagnosticTimeTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderChooseDiagnosticTimeTable.vue?vue&type=style&index=0&id=58df30c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df30c0",
  null
  
)

export default component.exports